import React from "react";
import { Modal, Box, Typography, Stack } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

import colors from "../../../../../utils/colors";
import { CancelButton, SaveButton } from "../../../../common/Button";

const DRAWER_Z_INDEX = 1300;

/**
 * Themed confirm dialog for discarding unsaved side-drawer edits.
 * Matches FormDrawer chrome (primary tint icon, Save/Cancel buttons).
 */
const UnsavedChangesConfirmModal = ({
  open,
  onCancel,
  onContinue,
  title = "Discard unsaved changes?",
  body = "Your data will be lost if you continue without saving.",
  cancelLabel = "Cancel",
  continueLabel = "Continue",
  loading = false,
}) => (
  <Modal
    open={!!open}
    onClose={loading ? undefined : onCancel}
    sx={{ zIndex: DRAWER_Z_INDEX + 100 }}
    slotProps={{
      backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0.5)" } },
    }}
  >
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 420,
        maxWidth: "94vw",
        backgroundColor: "#fff",
        borderRadius: "8px",
        p: 4,
        boxShadow: "0 12px 32px rgba(17,17,17,0.08), 0 4px 8px rgba(17,17,17,0.04)",
      }}
    >
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: "8px",
            backgroundColor: "#EEF0FE",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <WarningAmberOutlinedIcon sx={{ color: colors.primary[300], fontSize: 28 }} />
        </Box>
        <Box sx={{ minWidth: 0, pt: 0.25 }}>
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: "medium",
              lineHeight: "27px",
              color: colors.neutral[1000],
              mb: 1,
            }}
          >
            {title}
          </Typography>
          <Typography sx={{ fontSize: 14, lineHeight: "21px", color: colors.neutral[700] }}>
            {body}
          </Typography>
        </Box>
      </Stack>

      <Stack direction="row" spacing={3} justifyContent="flex-end" sx={{ mt: 4 }}>
        <CancelButton
          onClick={onCancel}
          disabled={loading}
          label={cancelLabel}
          sx={{ width: "auto", minWidth: 120, height: 36 }}
        />
        <SaveButton
          onClick={onContinue}
          disabled={loading}
          loading={loading}
          label={continueLabel}
          sx={{ width: "auto", minWidth: 120, height: 36 }}
        />
      </Stack>
    </Box>
  </Modal>
);

export default UnsavedChangesConfirmModal;
